import { render } from "./PantryIngredientFoodView.vue?vue&type=template&id=efff24fa&ts=true"
import script from "./PantryIngredientFoodView.vue?vue&type=script&lang=ts"
export * from "./PantryIngredientFoodView.vue?vue&type=script&lang=ts"

import "./PantryIngredientFoodView.vue?vue&type=style&index=0&id=efff24fa&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__